import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';

const base = () => `${process.env.REACT_APP_API_URL}/api/v3/task-platforms`;
const config = () => ({ headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } });

/**
 * Where a video or post goes out (YouTube, Instagram/Facebook...). Everyone signed in can list
 * them; only admins can add, rename, hide or reorder. Each is { key, label, order, hidden }.
 */
const TaskPlatformService = {
    list: async () => (await axios.get(base(), config())).data,
    create: async (label) => (await axios.post(base(), { label }, config())).data,
    update: async (key, body) => (await axios.put(`${base()}/${key}`, body, config())).data,
};

export default TaskPlatformService;
